import { useCallback, useState } from "react";

/**
 * A hook to toggle a value
 * @param initialValue The initial value
 * @returns The value and a function to toggle it
 * @example
 * ```
 * const [on, toggle] = useToggle(false)
 * return <button onClick={toggle}>{on ? "On" : "Off"}</button>
 * ```
 */

export function useToggle(initialValue?: boolean): [boolean, (newValue?: unknown) => void] {
  const [on, setOn] = useState(() => {
    if (typeof initialValue === "boolean") {
      return initialValue;
    }

    return Boolean(initialValue);
  });

  const handleToggle = useCallback((value?: unknown) => {
    if (typeof value === "boolean") {
      return setOn(value);
    }

    return setOn((v) => !v);
  }, []);

  return [on, handleToggle];
}
